module.exports = __webpack_public_path__ + "img/mapa.5353c8c4.png";